import axios from "axios";
import { LANDING_URL } from "./endpoints/landing";

async function getRoleByUser({ request }) {
  const payload = {"userEmail":request?.email || ""};

  return await axios.post(LANDING_URL.GetRole, payload, {
    headers: {
      "Content-Type": "application/json",
      Accept: "application/json",
    },
  });
}

async function getRegionByUser({ request }) {
  const payload = request || {};

  return await axios.post(LANDING_URL.GetRegion, payload, {
    headers: {
      "Content-Type": "application/json",
      Accept: "application/json",
    },
  });
}

export { getRoleByUser, getRegionByUser };
